import { Component, Input, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { GroupButton } from '@componentes/public-button-group/public-button-group.component';

@Component({
	selector: 'seira-export-button',
	templateUrl: './export-button.component.html',
	styleUrls: ['./export-button.component.scss'],
})
export class ExportButtonComponent {
	@Input() label = 'exportar...';
	@Input() icon = 'ph-export';
	@Input() buttons: GroupButton[] = [];
	@Input() disabledButton = false;
	@Input() altura = '84px';
	@Input() tamanhoIcone = '36px';
	@Input() paddingCompacto = false;
	@Input() largura = '90px';
	@Input() orientacao: 'column' | 'row' = 'column';
	modalRef?: BsModalRef;

	constructor(private modalService: BsModalService) {}

	onClick(template: TemplateRef<any>) {
		this.modalRef = this.modalService.show(template);
	}
}
